import SellerDashboard from '../../components/seller/SellerDashboard';

const SellerDashboardPage = () => <SellerDashboard />;

export default SellerDashboardPage;
